var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.9499 33.6236C26.1546 33.6236 33.6165 26.1617 33.6165 16.957C33.6165 7.7522 26.1546 0.290283 16.9499 0.290283C7.74512 0.290283 0.283203 7.7522 0.283203 16.957C0.283203 26.1617 7.74512 33.6236 16.9499 33.6236Z",
    fill: "#007AFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9501 14.0071L17.1168 11.2237C15.9168 10.5237 14.4668 10.5237 13.2668 11.2237C12.0668 11.9237 11.3501 13.1571 11.3501 14.5571L11.3501 20.1404C11.3501 21.5237 12.0668 22.7737 13.2668 23.4737C13.8668 23.8237 14.5334 23.9904 15.1834 23.9904C15.8501 23.9904 16.5001 23.8237 17.1001 23.4737L21.9334 20.6904C23.1334 19.9904 23.8501 18.7571 23.8501 17.3571C23.8834 15.9571 23.1668 14.7071 21.9501 14.0071Z",
    fill: "#007AFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.fdc8703cd5e7fdb7ffd8e70c5ac3149a.svg";
export { ForwardRef as ReactComponent };